import {
	Component,
	ChangeDetectionStrategy,
	OnInit,
	inject,
	ViewChild,
	ElementRef,
	ChangeDetectorRef,
	afterNextRender,
	AfterRenderPhase,
	NgZone,
	PLATFORM_ID,
	Inject,
} from '@angular/core';
import _ from 'lodash';
import {
	isPlatformBrowser
} from '@angular/common';
import { SeoService } from 'app/services/seo.service';

@Component({
	selector: 'contact',
	templateUrl: '../templates/contact.pug',
	styleUrls: ['../styles/contact.scss'],
	host: { class: 'contact' },
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactComponent implements OnInit {

	@ViewChild( 'toolbar' )
	protected toolbar!: ElementRef;
	@ViewChild( 'navbar' )
	protected navbar!: ElementRef;
	@ViewChild( 'hero' )
	protected hero!: ElementRef;

	protected readonly _cdr: ChangeDetectorRef
		= inject( ChangeDetectorRef );

	protected filterType: string;
	protected searchValue: string;

	constructor(
		@Inject( PLATFORM_ID ) private _platformId: Object,
		private _ngZone: NgZone,
		private _seo: SeoService
	) {
		afterNextRender(() => {
			if ( isPlatformBrowser( this._platformId ) ) {
				this._ngZone.runOutsideAngular( () => {
					setTimeout(() => {
					}, 100);
				});
			}
		}, { phase: AfterRenderPhase.MixedReadWrite });
	}

	ngOnInit(): void {
		this._seo.updateTags([
			{ name: 'description', content: 'Giới thiệu về Đồng Quê - Đơn vị cung cấp thực phẩm sạch, an toàn tại Quy Nhơn, Gia Lai. Liên hệ Đồng Quê để được tư vấn và đặt hàng thực phẩm tươi sống tại Quy Nhơn, Gia Lai.' },
			{ name: 'keywords', content: 'liên hệ, thực phẩm sạch, tư vấn, đặt hàng, Quy Nhơn, Gia Lai' },
			{ property: 'og:title', content: 'Liên Hệ - Thực Phẩm Đồng Quê' },
			{ property: 'og:description', content: 'Liên hệ Đồng Quê để được tư vấn và đặt hàng thực phẩm tươi sống.' }
		]);
		this._seo.setLink();
	}
}
